import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";

export const SiteFooter = () => {
  const { t } = useT();
  return (
    <footer
      id="contatti"
      data-testid="site-footer"
      className="bg-primary text-primary-foreground mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display text-3xl mb-3">Hotel Due Pini Conte</div>
          <div className="font-display text-xl text-white/70 mb-6">
            & G&amp;A Conte B&amp;B
          </div>
          <p className="text-white/70 leading-relaxed max-w-md">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <div className="label-eyebrow text-white/80 mb-4">{t("footer.contatti")}</div>
          <ul className="space-y-3 text-white/85">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 shrink-0" />
              <span>{t("footer.location")}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-1 shrink-0" />
              <a
                href="tel:+39081947556"
                data-testid="footer-phone"
                className="hover:underline"
              >
                081 947 556
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle className="w-4 h-4 mt-1 shrink-0 text-emerald-300" />
              <a
                href="https://wa.me/393880925320"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="hover:underline"
              >
                WhatsApp · 388 092 5320
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-1 shrink-0" />
              <a
                href="mailto:infohotelduepini@gmail.com"
                data-testid="footer-email"
                className="hover:underline break-all"
              >
                infohotelduepini@gmail.com
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-white/80 mb-4">{t("footer.prenota")}</div>
          <ul className="space-y-2 text-white/85">
            <li>
              <Link
                to="/prenota/pernottamenti"
                data-testid="footer-link-overnight"
                className="hover:underline"
              >
                {t("footer.overnight")}
              </Link>
            </li>
            <li>
              <Link
                to="/prenota/dayuse"
                data-testid="footer-link-dayuse"
                className="hover:underline"
              >
                {t("footer.dayuse")}
              </Link>
            </li>
            <li>
              <Link
                to="/admin/login"
                data-testid="footer-link-admin"
                className="hover:underline text-white/60"
              >
                {t("footer.admin")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 pb-16">
        <div className="label-eyebrow text-white/80 mb-4">{t("footer.dove_siamo")}</div>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="rounded-2xl overflow-hidden border border-white/10 shadow-xl">
            <div className="bg-white/5 px-4 py-3 text-sm">
              <div className="font-display text-lg text-white">Hotel Due Pini Conte</div>
              <div className="text-white/60 text-xs">Via del Monte 40 · Angri (SA)</div>
            </div>
            <iframe
              title="Hotel Due Pini Conte · Angri"
              data-testid="footer-map-hotel"
              src="https://maps.google.com/maps?q=Hotel%20Due%20Pini%20Conte%2C%20Via%20del%20Monte%2040%2C%20Angri%2C%20Salerno&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="260"
              style={{ border: 0, display: "block", filter: "saturate(0.9)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
          <div className="rounded-2xl overflow-hidden border border-white/10 shadow-xl">
            <div className="bg-white/5 px-4 py-3 text-sm">
              <div className="font-display text-lg text-white">G&amp;A Conte B&amp;B</div>
              <div className="text-white/60 text-xs">Via Petaccia 23 · Angri (SA)</div>
            </div>
            <iframe
              title="G&A Conte B&B · Angri"
              data-testid="footer-map-bnb"
              src="https://maps.google.com/maps?q=Via%20Petaccia%2023%2C%20Angri%2C%20Salerno&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="260"
              style={{ border: 0, display: "block", filter: "saturate(0.9)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/50 text-xs">
        © {new Date().getFullYear()} Hotel Due Pini Conte · Angri (SA) · P.IVA
        —
      </div>
    </footer>
  );
};
